import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';

import Typography from '@material-ui/core/Typography';

import Avatar from '@material-ui/core/Avatar';
import Collapse from '@material-ui/core/Collapse';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  commentBox: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    paddingRight: '10px'
  },
  media: {
    height: 0
  },
  actions: {
    display: 'flex',
    padding: 0
  },
  toolBar: {
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: 0
  }
}));

const PostCard = ({
  title,
  subtitle,
  text,
  image,
  imageHeight,
  avatar,
  comments
}) => {
  const classes = useStyles();
  const [searchExpanded, setSearchExpanded] = useState(true);
  const handleSearchExpandToggle = () => setSearchExpanded(!searchExpanded);

  return (
    <Card>
      <CardHeader avatar={avatar} subheader={subtitle} title={title} />
      <CardMedia
        className={classes.media}
        image={image}
        style={{ paddingTop: imageHeight }}
        title={title}
      />
      <CardContent>
        <Typography className={classes.clamp} component="p">
          {text}
        </Typography>
      </CardContent>
      <CardActions className={classes.actions} disableSpacing>
        <Toolbar className={classes.toolBar} disableGutters>
          <form className={classes.commentBox}>
            <IconButton aria-label="Search" className={classes.searchIcon}>
              <Avatar>X</Avatar>
            </IconButton>
            <TextField
              fullWidth
              id="comment-box-field"
              placeholder="Write a comment"
              variant="outlined"
            />
          </form>
        </Toolbar>
      </CardActions>

      <Button color="default" onClick={handleSearchExpandToggle} variant="text">
        {searchExpanded ? 'Hide Comments' : 'Show Comments'}
      </Button>

      <CardActions className={classes.actions} disableSpacing>
        <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
          <Toolbar className={classes.toolBar} disableGutters>
            <form className={classes.commentBox}>
              <IconButton aria-label="Search" className={classes.searchIcon}>
                <Avatar>X</Avatar>
              </IconButton>
              <Typography color="initial" variant="p">
                My Name
              </Typography>
              <Typography color="initial" variant="p">
                Comment section with text
              </Typography>
            </form>
          </Toolbar>
        </Collapse>
      </CardActions>
    </Card>
  );
};

PostCard.propTypes = {
  avatar: PropTypes.element,
  comments: PropTypes.string,
  image: PropTypes.string,
  imageHeight: PropTypes.number,
  subtitle: PropTypes.string,
  text: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default PostCard;
